import React from 'react'
import { MacrosDistribution } from '@/api/types'
import { TextField } from '@/components/TextField'
import './EnergyDistributionComponent.css'

export default function EnergyDistributionComponent({
  energyDistribution,
  onChange,
}: {
  energyDistribution: MacrosDistribution
  onChange: (value: MacrosDistribution) => void
}) {
  function getDistributionValue(dist: number) {
    return Math.round(dist * 100) + ''
  }

  function handleChangeCarbs(value: string) {
    if (value === '') {
      value = '0'
    }
    const carbs = parseFloat(value) / 100
    const fat = 1 - carbs - energyDistribution.proteinDistribution

    onChange({
      ...energyDistribution,
      carbohydratesDistribution: carbs,
      fatDistribution: fat,
    })
  }

  function handleChangeFat(value: string) {
    if (value === '') {
      value = '0'
    }
    const fat = parseFloat(value) / 100
    const carbs = 1 - fat - energyDistribution.proteinDistribution

    onChange({
      ...energyDistribution,
      carbohydratesDistribution: carbs,
      fatDistribution: fat,
    })
  }

  function handleChangeProtein(value: string) {
    if (value === '') {
      value = '0'
    }
    const protein = parseFloat(value) / 100
    const carbs = 1 - protein - energyDistribution.fatDistribution

    onChange({
      ...energyDistribution,
      carbohydratesDistribution: carbs,
      proteinDistribution: protein,
    })
  }

  return (
    <div style={{ display: 'flex', maxWidth: '300px', gap: '10px' }}>
      <div>
        <TextField
          value={getDistributionValue(energyDistribution.proteinDistribution)}
          onChange={handleChangeProtein}
          style={{ width: '100px' }}
        />
        <div className="EnergyDistributionComponent_macro_label">Protein</div>
      </div>
      <div>
        <TextField
          value={getDistributionValue(energyDistribution.carbohydratesDistribution)}
          onChange={handleChangeCarbs}
          style={{ width: '100px' }}
        />
        <div className="EnergyDistributionComponent_macro_label">Carbs</div>
      </div>
      <div>
        <TextField
          value={getDistributionValue(energyDistribution.fatDistribution)}
          onChange={handleChangeFat}
          style={{ width: '100px' }}
        />
        <div className="EnergyDistributionComponent_macro_label">Fat</div>
      </div>
    </div>
  )
}
